import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import api from "@/api/api";
import { onMounted } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupView',
  setup(__props) {

const route = useRoute();
const ref = route.query.ref;

onMounted(async () => {
  if (ref) {
    const res = await api.auth.getSignupUrl(ref);
    return (window.location.href = res.url);
  }

  const res = await api.auth.getSignupUrl();
  return (window.location.href = res.url);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})